import { Widget } from '@uploadcare/react-widget';
import { useState, useEffect } from 'react';
import styles from './UploadcareUploader.module.css';

const UploadcareUploader = ({ label, onUpload, value, name }) => {
  const [preview, setPreview] = useState(value || '');

  useEffect(() => {
    setPreview(value || '');
  }, [value]);

  const handleUpload = (fileInfo) => {
    if (fileInfo?.cdnUrl) {
      setPreview(fileInfo.cdnUrl);
      onUpload(name, fileInfo.cdnUrl);
    }
  };

  const handleFileSelect = (file) => {
    if (!file) {
      setPreview('');
      onUpload(name, '');
    }
  };

  return (
    <div className={styles.uploader}>
      {label && <label className={styles.label}>{label}</label>}
      <Widget
        publicKey={process.env.REACT_APP_UPLOADCARE_PUBLIC_KEY}
        onChange={handleUpload}
        onFileSelect={handleFileSelect}
        tabs="file camera url"
        previewStep
        clearable
        value={preview}
      />
      {preview && (
        <img src={preview} alt="Uploaded preview" className={styles.preview} />
      )}
    </div>
  );
};

export default UploadcareUploader;